export default __webpack_public_path__ + "static/media/Frame767.45493639.png";